import Head from "next/head";

export default function About() {
	return (
		<>
		<Head>
			<title>Om Cherryblossom.no | Prissammenligning for skjønnhet</title>
			<meta name="description" content="Les om Cherryblossom.no og hvordan vi hjelper deg å sammenligne priser på skjønnhetsprodukter fra norske nettbutikker." />
			<link rel="canonical" href="https://cherryblossom.no/om-oss" />
			<meta property="og:url" content="https://cherryblossom.no/om-oss" />
		</Head>
		<div style={{padding: '16px'}}>
		<h1>Om Cherryblossom.no</h1>
			<article>
				<p>
					Cherryblossom.no er en tjeneste som hjelper deg å sammenligne priser på produkter fra ulike nettbutikker innen skjønnhet og velvære.
					Vi samler produktkatalogene til en rekke produsenter og leverandører slik at du enkelt kan sammenligne priser og finne det beste tilbudet.
					På denne måten, får du god oversikt over produktene på markedet og kan enkelt finne det som passer deg og din lommebok best! 🎉 
				</p>
				<h2>Kontakt</h2>
				<p>
					Spørsmål, ris eller ros? Send oss gjerne en e-post på <a href="mailto:cherryblossom@babymoon.no" rel="nofollow">cherryblossom@babymoon.no</a>.
				</p>
				<h2>Partnere</h2>
				<p>
					Cherryblossom.no reklamerer gjennom annonselenker til våre samarbeidspartnere.
				</p>
				<h2>Babymoon.no</h2>
				<p>
					Cherryblossom drives av <a href="https://babymoon.no" rel="nofollow" title="Klikk for å besøke Babymoon.no" target="_blank">Babymoon.no</a>, som er en tjeneste som hjelper småbarnsforeldre å sammenligne priser på produkter for småbarnsforeldre.
				</p>
			</article>
			</div>
		</>
	)
}
